import React from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons";
import { useState } from "react";
import { Auth } from "aws-amplify";
import awsconfig from "../../aws-exports";
import Amplify from "@aws-amplify/core";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { withRouter } from "react-router-dom";

Amplify.configure(awsconfig);

const useStyles = makeStyles({
  img: {
    width: "100%",
    height: "100vh",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  input: {
    marginTop: "30px",
    width: "50%",
  },
  button: {
    width: "50%",
    marginTop: "30px",
    backgroundColor: "#5555b2",
    color: "white",
    fontWeight: "500",
    height: "50px",
  },
  textBox: {
    textAlign: "center",
    fontSize: "40px",
    height: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const initialFormState = {
  email: "",
  new_password: "",
  code: "",
  rpassword: "",
  formType: "verify",
};

const ForgotPassword = ({ history }) => {
  const [formState, updateFormState] = useState(initialFormState);
  const [snackOpen, setSnackOpen] = useState({ open: false, message: "" });
  const [showPass, setShowPass] = useState({
    pass: false,
    rPass: false,
  });
  const [isValid, setIsValid] = useState({
    email: {
      valid: true,
      error: "",
    },
    new_password: {
      valid: true,
      error: "",
    },
    rpassword: {
      valid: true,
      error: "",
    },
    code: {
      valid: true,
      error: "",
    },
  });
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const SnackOpenHandler = (message) => {
    setSnackOpen({ open: true, message });
  };
  const SnackCloseHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ open: false, message: "" });
  };
  const classes = useStyles();

  const isValidHanlder = (name, value) => {
    let emailRegex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
    switch (name) {
      case "code":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            code: { valid: false, error: "Invalid code!" },
          });
        } else {
          setIsValid({ ...isValid, code: { valid: true, error: "" } });
        }
        break;
      case "email":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Input!" },
          });
        } else if (!emailRegex.test(value)) {
          setIsValid({
            ...isValid,
            email: { valid: false, error: "Invalid Email!" },
          });
        } else {
          setIsValid({ ...isValid, email: { valid: true, error: "" } });
        }
        break;

      case "new_password":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            new_password: { valid: false, error: "Invalid Password!" },
          });
        } else if (value.length < 8) {
          setIsValid({
            ...isValid,
            new_password: {
              valid: false,
              error: "Password must be 8 character long!",
            },
          });
        } else {
          setIsValid({ ...isValid, new_password: { valid: true, error: "" } });
        }
        break;
      case "rpassword":
        if (value.length < 3) {
          setIsValid({
            ...isValid,
            rpassword: { valid: false, error: "Invalid Password!" },
          });
        } else if (value !== formState.new_password) {
          setIsValid({
            ...isValid,
            rpassword: { valid: false, error: "Password should be same!" },
          });
        } else {
          setIsValid({ ...isValid, rpassword: { valid: true, error: "" } });
        }
        break;
      default:
        return;
    }
  };

  function onChange(e) {
    e.preventDefault();
    isValidHanlder(e.target.name, e.target.value);
    updateFormState(() => ({
      ...formState,
      [e.target.name]: e.target.value,
    }));
  }

  const { formType } = formState;

  async function sendEmail(e) {
    e.preventDefault();
    const { email } = formState;
    if (email.length > 0 && isValid.email.valid) {
      await Auth.forgotPassword(email)
        .then((data) => {
          updateFormState(() => ({
            ...formState,
            formType: "verified",
          }));
        })
        .catch((err) => {
          SnackOpenHandler(err.message);
        });
    } else {
      SnackOpenHandler("Invalid Email!");
    }
  }

  const checkValid = () => {
    if (
      formState.code.length < 1 ||
      formState.email.length < 1 ||
      formState.new_password.length < 1 ||
      formState.rpassword.length < 1 ||
      !isValid.code.valid ||
      !isValid.new_password.valid ||
      !isValid.email.valid ||
      !isValid.rpassword.valid
    ) {
      return false;
    } else {
      return true;
    }
  };

  const confirmCode = async (e) => {
    e.preventDefault();
    const { email, code, new_password, rpassword } = formState;
    if (checkValid().valueOf(true)) {
      Auth.forgotPasswordSubmit(email, code, new_password)
        .then((data) => {
          history.push("/login");
        })
        .catch((err) => {
          SnackOpenHandler(err.message);
        });
    } else {
      SnackOpenHandler("Invalid Password or Code!");
    }
  };

  return (
    <>
      {formType === "verify" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Forgot Password?
            </Typography>
            <form
              onSubmit={sendEmail}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                label="Registered Email-Id"
                type="text"
                inputProps={{
                  "aria-label": "EmailId",
                }}
                error={!isValid.email.valid}
                helperText={!isValid.email.valid && isValid.email.error}
                name="email"
                onChange={onChange}
                variant="outlined"
                required
                autoComplete="email"
              />

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
              >
                Send Verification Code
              </Button>
              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}

      {formType === "verified" && (
        <Grid container>
          <Grid item sm={12} xs={12} md={6} lg={6}>
            <Typography className={classes.textBox}>
              Forgot Password?
            </Typography>
            <form
              onSubmit={confirmCode}
              className={classes.form}
              noValidate
              autoComplete="off"
            >
              <TextField
                className={classes.input}
                label="Verification-Code"
                type="text"
                name="code"
                error={!isValid.code.valid}
                helperText={!isValid.code.valid && isValid.code.error}
                onChange={onChange}
                variant="outlined"
                required
                inputProps={{
                  "aria-label": "OtpCode",
                  autoComplete: "new-password",
                  form: {
                    autoComplete: "off",
                  },
                }}
              />
              <TextField
                className={classes.input}
                label="New Password"
                type={showPass.pass ? "text" : "password"}
                name="new_password"
                onChange={onChange}
                variant="outlined"
                required
                error={!isValid.new_password.valid}
                helperText={
                  !isValid.new_password.valid && isValid.new_password.error
                }
                inputProps={{
                  "aria-label": "newPassword",
                  autoComplete: "new-password",
                  form: {
                    autoComplete: "off",
                  },
                }}
                InputProps={{
                  endAdornment: formState.new_password.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.pass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, pass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                className={classes.input}
                label="Confirm Password"
                type={showPass.rPass ? "text" : "password"}
                name="rpassword"
                onChange={onChange}
                variant="outlined"
                required
                error={!isValid.rpassword.valid}
                helperText={!isValid.rpassword.valid && isValid.rpassword.error}
                inputProps={{
                  "aria-label": "rpassword",
                  autoComplete: "new-password",
                  form: {
                    autoComplete: "off",
                  },
                }}
                InputProps={{
                  endAdornment: formState.rpassword.length > 0 && (
                    <InputAdornment classes={classes.inputIcon} position="end">
                      {!showPass.rPass ? (
                        <VisibilityOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, rPass: true })
                          }
                        />
                      ) : (
                        <VisibilityOffOutlined
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setShowPass({ ...showPass, rPass: false })
                          }
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                type="submit"
              >
                Submit
              </Button>
              <Snackbar
                open={snackOpen.open}
                autoHideDuration={6000}
                onClose={SnackCloseHandler}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert onClose={SnackCloseHandler} severity="error">
                  {snackOpen.message}
                </Alert>
              </Snackbar>
            </form>
          </Grid>
          <Grid item lg={6} md={6}>
            <Box display={{ xs: "none", md: "block", lg: "block" }}>
              <img
                className={classes.img}
                src="https://images.unsplash.com/photo-1616277434251-0e5188ccbe00?ixid=MXwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
                alt="images"
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default withRouter(ForgotPassword);
